module.exports = __webpack_public_path__ + "25f35685351321335981535e090142a3.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1089
// module chunks = 0